import React from 'react';
import { TruncatedText } from '@/se/components/typography';

import { OR, PACU, POST_OP, PRE_OP, ROOM_TYPE_LABELS } from './enums';
import { sortNumber } from '@/util/sort';
import DailyCapacityView from './views/DailyCapacityView';

export const nameColumn = {
  title: 'Name',
  lens: data => data.name,
  Component: props => <TruncatedText>{props.data}</TruncatedText>,
};

export const baseColumns = [
  {
    title: 'Type',
    lens: data => ROOM_TYPE_LABELS[data.type],
    Component: props => <TruncatedText>{props.data}</TruncatedText>,
  },
  {
    title: 'Capacity',
    lens: data => ([PRE_OP, PACU, POST_OP].includes(data.type) ? data.capacity : undefined),
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.capacity, r.capacity),
  },
  {
    title: 'Daily capacity in minutes',
    lens: data =>
      data.type === OR ? `${(data.availability ? data.availability * 60 + 'm' : false) || '–'}` : undefined,
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.availability, r.availability),
  },
  {
    title: 'Day by day capacity in minutes',
    lens: data => (data.type === OR ? data.dailyAvailability : undefined),
    Component: ({ data }) => (data ? <DailyCapacityView dailyCapacity={data} /> : null),
    sortFunction: (l, r) => sortNumber(l.availability, r.availability),
  },
  {
    title: 'Exclude from OR Utilization',
    lens: data => (data.type === OR ? (data.openType ? 'Yes' : 'No') : undefined),
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.openType ? 1 : 0, r.openType ? 1 : 0),
  },
  {
    title: 'Air Filtration Duration',
    lens: data => (data.airFiltrationDurationMin ? data.airFiltrationDurationMin + ' min' : undefined),
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.airFiltrationDurationMin, r.airFiltrationDurationMin),
  },
  {
    title: 'Turnover Clock Warning Threshold 1',
    lens: data => (data.warningThreshold ? data.warningThreshold + ' min' : undefined),
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.warningThreshold, r.warningThreshold),
  },
  {
    title: 'Turnover Clock Alert Threshold 2',
    lens: data => (data.alertThreshold ? data.alertThreshold + ' min' : undefined),
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.alertThreshold, r.alertThreshold),
  },
  {
    title: 'OoB Warning Threshold',
    lens: data =>
      data.type === PACU ? (data.oobWarningThreshold ? data.oobWarningThreshold + ' min' : '-') : undefined,
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.oobWarningThreshold, r.oobWarningThreshold),
  },
  {
    title: 'PT Warning Threshold',
    lens: data => (data.type === PACU ? (data.ptWarningThreshold ? data.ptWarningThreshold + ' min' : '-') : undefined),
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.ptWarningThreshold, r.ptWarningThreshold),
  },
  {
    title: 'PT Complete Warning Threshold',
    lens: data =>
      data.type === PACU
        ? data.ptCompleteWarningThreshold
          ? data.ptCompleteWarningThreshold + ' min'
          : '-'
        : undefined,
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.ptCompleteWarningThreshold, r.ptCompleteWarningThreshold),
  },
  {
    title: 'PACU Out Warning Threshold',
    lens: data =>
      data.type === PACU ? (data.pacuOutWarningThreshold ? data.pacuOutWarningThreshold + ' min' : '-') : undefined,
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.pacuOutWarningThreshold, r.pacuOutWarningThreshold),
  },
  {
    title: 'OR Order',
    lens: data => (data.type === OR ? `${(data.order ? data.order : false) || '–'}` : undefined),
    Component: ({ data }) => <TruncatedText>{data}</TruncatedText>,
    sortFunction: (l, r) => sortNumber(l.order, r.order),
  },
];
